import { createFileRoute } from '@tanstack/react-router';
import { AttendanceLogicComponentDetailLayout } from './-components/AttendanceLogicComponentDetailLayout';
export const Route = createFileRoute('/_staff/attendance-engine/_layout/logic-components/$componentId/_layout')({
  component: AttendanceLogicComponentDetailLayout
});